﻿/* 
Object:         Google Maps
Description:    Handler for Google Maps using the token in the appsettings configuration
Used in:        Modules where Google Maps is beging used.
*/

/*---[ ESLint ]---*/
/*
    global google
*/

window.googlemaps = function () {
    var nawMarker;

    function ToCoordinateNumber(cooridnateString) {
        var result = Number(cooridnateString.replace(',', '.'));

        return result;
    }

    /**
    * place markers and navigate to / pan to ..
    * @param {any} latLng
    * @param {any} map
    */
    function placeMarkerAndPanTo(latLng, map) {
        if (nawMarker !== undefined) {
            nawMarker.setMap(null);
        }

        nawMarker = new google.maps.Marker({
            position: latLng,
            map: map
        });

        map.panTo(latLng);

        //update position
        var naw_latitude = $('#LatitudeString');
        var naw_longitude = $('#LongitudeString');
        naw_latitude.val(latLng.lat());
        naw_longitude.val(latLng.lng());
    }

    return {
        

        /**
         * init google maps
         * @param {any} divid
         * @param {double} latitude
         * @param {double} longitude
         * @param {boolean} editmode
         * @param {integer} mapsZoom
         */
        initialize: function (divid, input_latitude_string, input_longitude_string, editmode, mapsZoom) {
            // The location of the center
            var latitude = ToCoordinateNumber(input_latitude_string);
            var longitude = ToCoordinateNumber(input_longitude_string);

            // Center position maps
            var center = { lat: latitude, lng: longitude };

            // Create the map
            map = new google.maps.Map(document.getElementById(divid), { zoom: mapsZoom, center: center });

            // Marker
            var marker = { lat: latitude, lng: longitude };

            //place the marker
            nawMarker = new google.maps.Marker({
                position: marker,
                map: map
            });

            if (editmode) {
                map.addListener('click', function (e) {
                    placeMarkerAndPanTo(e.latLng, map);
                });
            }
        },

        /**
         * update longitude and latitude
         * @param {any} googleApiKey
         */
        updateLonitudeLatitude: function (googleApiKey, address) {            

            // Web request to the google service. This will tranform the address into a longitude and latitude
            var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(address) + '&key=' + googleApiKey;

            // place marker in callback
            $.get(url, function (geoCodingResult) {

                //process result;
                if (geoCodingResult.status === 'OK') {

                    var lat = geoCodingResult.results[0].geometry.location.lat;
                    var lng = geoCodingResult.results[0].geometry.location.lng;

                    $("#LatitudeStr").data("kendoTextBox").value(lat.toLocaleString(undefined, { minimumFractionDigits: 6 }));
                    $("#LongitudeStr").data("kendoTextBox").value(lng.toLocaleString(undefined, { minimumFractionDigits: 6 }));

                    var latlng = new google.maps.LatLng({ lat: lat, lng: lng });

                    placeMarkerAndPanTo(latlng, map);
                }
            });

        }
    }

}();